/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Origin_Link_TextInputs */

const en_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get quick answers about Brave Origin`)
};

const id_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan jawaban cepat tentang Brave Origin`)
};

const ms_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan jawapan pantas tentang Brave Origin`)
};

const ca_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obté respostes ràpides sobre Brave Origin`)
};

const cs_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získejte rychlé odpovědi o Brave Origin`)
};

const da_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få hurtige svar om Brave Origin`)
};

const de_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhalten Sie schnelle Antworten zu Brave Origin.`)
};

const et_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saa kiireid vastuseid Brave Origin kohta`)
};

const es_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén respuestas rápidas sobre Brave Origin`)
};

const fr_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenez des réponses rapides à propos de Brave Origin`)
};

const hr_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobijte brze odgovore o Brave Origin`)
};

const it_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni risposte rapide su Brave Origin`)
};

const lv_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saņemiet ātras atbildes par Brave Origin`)
};

const lt_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaukite greitus atsakymus apie Brave Origin`)
};

const hu_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyors válaszok a Brave Origin-ről`)
};

const nl_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krijg snel antwoord op vragen over Brave Origin`)
};

const nb_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få raske svar om Brave Origin`)
};

const pl_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzyskaj szybkie odpowiedzi na temat Brave Origin`)
};

const pt_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha respostas rápidas sobre o Brave Origin`)
};

const ro_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obține răspunsuri rapide despre Brave Origin`)
};

const sk_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získajte rýchle odpovede o Brave Origin`)
};

const sl_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hitri odgovori o Brave Origin`)
};

const fi_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat nopeasti vastauksia Brave Originista`)
};

const sv_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få snabba svar om Brave Origin`)
};

const vi_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận câu trả lời nhanh về Brave Origin`)
};

const tr_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin hakkında hızlı yanıtlar alın`)
};

const el_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λάβετε γρήγορες απαντήσεις σχετικά με το Brave Origin`)
};

const bg_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получете бързи отговори относно Brave Origin`)
};

const ru_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите быстрые ответы о Brave Origin`)
};

const sr_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Брзи одговори о Brave Origin`)
};

const uk_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримайте швидкі відповіді про Brave Origin`)
};

const ka_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მიიღეთ სწრაფი პასუხები Brave Origin-ის შესახებ`)
};

const hi_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin के बारे में त्वरित उत्तर प्राप्त करें`)
};

const th_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับคำตอบอย่างรวดเร็วเกี่ยวกับ Brave Origin`)
};

const ko_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin에 대한 빠른 답변 얻기`)
};

const zh_tw_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速取得有關 Brave Origin 的解答`)
};

const ja_brave_origin_link_text = /** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Originに関する簡単な回答を得る`)
};

/** @type {(inputs: Brave_Origin_Link_TextInputs) => LocalizedString} */
const zh_brave_origin_link_text = en_brave_origin_link_text;

/**
* | output |
* | --- |
* | "Get quick answers about Brave Origin" |
*
* @param {Brave_Origin_Link_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_origin_link_text = /** @type {((inputs?: Brave_Origin_Link_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Origin_Link_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_origin_link_text(inputs)
	if (locale === "ms") return ms_brave_origin_link_text(inputs)
	if (locale === "ca") return ca_brave_origin_link_text(inputs)
	if (locale === "cs") return cs_brave_origin_link_text(inputs)
	if (locale === "da") return da_brave_origin_link_text(inputs)
	if (locale === "de") return de_brave_origin_link_text(inputs)
	if (locale === "et") return et_brave_origin_link_text(inputs)
	if (locale === "es") return es_brave_origin_link_text(inputs)
	if (locale === "fr") return fr_brave_origin_link_text(inputs)
	if (locale === "hr") return hr_brave_origin_link_text(inputs)
	if (locale === "it") return it_brave_origin_link_text(inputs)
	if (locale === "lv") return lv_brave_origin_link_text(inputs)
	if (locale === "lt") return lt_brave_origin_link_text(inputs)
	if (locale === "hu") return hu_brave_origin_link_text(inputs)
	if (locale === "nl") return nl_brave_origin_link_text(inputs)
	if (locale === "nb") return nb_brave_origin_link_text(inputs)
	if (locale === "pl") return pl_brave_origin_link_text(inputs)
	if (locale === "pt") return pt_brave_origin_link_text(inputs)
	if (locale === "ro") return ro_brave_origin_link_text(inputs)
	if (locale === "sk") return sk_brave_origin_link_text(inputs)
	if (locale === "sl") return sl_brave_origin_link_text(inputs)
	if (locale === "fi") return fi_brave_origin_link_text(inputs)
	if (locale === "sv") return sv_brave_origin_link_text(inputs)
	if (locale === "vi") return vi_brave_origin_link_text(inputs)
	if (locale === "tr") return tr_brave_origin_link_text(inputs)
	if (locale === "el") return el_brave_origin_link_text(inputs)
	if (locale === "bg") return bg_brave_origin_link_text(inputs)
	if (locale === "ru") return ru_brave_origin_link_text(inputs)
	if (locale === "sr") return sr_brave_origin_link_text(inputs)
	if (locale === "uk") return uk_brave_origin_link_text(inputs)
	if (locale === "ka") return ka_brave_origin_link_text(inputs)
	if (locale === "hi") return hi_brave_origin_link_text(inputs)
	if (locale === "th") return th_brave_origin_link_text(inputs)
	if (locale === "ko") return ko_brave_origin_link_text(inputs)
	if (locale === "zh") return zh_brave_origin_link_text(inputs)
	if (locale === "zh-tw") return zh_tw_brave_origin_link_text(inputs)
	if (locale === "ja") return ja_brave_origin_link_text(inputs)
	return en_brave_origin_link_text(inputs)
});